export default __webpack_public_path__ + "349533ed9ebae3a86ef292f1734a7efe.png";